import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/style.scss';
import * as Sentry from '@sentry/react';
import { auth } from 'services';
import { ModalContainer, setSpriteUrl } from '@ff-it/ui';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

setSpriteUrl('/sprites/regular.svg');

if (window.__RUNTIME_CONFIG__?.SENTRY_DSN) {
  Sentry.init({
    integrations: (defaults) =>
      defaults
        // disables autoSessionTracking https://docs.sentry.io/platforms/python/configuration/sessions/
        .filter((i) => i.name !== 'BrowserSession')
        .concat(
          // !IMPORTANT: wrapper in router.tsx
          Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
          }),
        ),
    tracesSampleRate: 0.01,
    replaysSessionSampleRate: 0,
    // replaysOnErrorSampleRate: 0,
    dsn: window.__RUNTIME_CONFIG__?.SENTRY_DSN,
    release: CLIENT_VERSION,
    environment: window.__RUNTIME_CONFIG__?.AGENCY_GROUP,
    initialScope: (scope) => {
      scope.setTags({
        'runtime-config-version': window.__RUNTIME_CONFIG__?.APP_VERSION,
        resolution: `${window.screen.width}x${window.screen.height}`,
      });
      scope.setUser(auth.user);
      return scope;
    },
    beforeSend(event) {
      event.tags = {
        ...event.tags,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
      };
      return event;
    },
  });
}

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <ModalContainer scope="ROOT" />
      <App />
    </StrictMode>,
  );
}
